export default function ExperienceIcon() {
  return (
    <svg
      width={18}
      height={16}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 10.5H16.5M12.125 3.625V2.375C12.125 2.04348 11.9933 1.72554 11.7589 1.49112C11.5245 1.2567 11.2065 1.125 10.875 1.125H7.125C6.79348 1.125 6.47554 1.2567 6.24112 1.49112C6.0067 1.72554 5.875 2.04348 5.875 2.375V3.625M2.125 3.625H15.875C16.2202 3.625 16.5 3.90482 16.5 4.25V14.25C16.5 14.5952 16.2202 14.875 15.875 14.875H2.125C1.77982 14.875 1.5 14.5952 1.5 14.25V4.25C1.5 3.90482 1.77982 3.625 2.125 3.625Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
